import { NhostClient } from "@nhost/react";

const nhost = new NhostClient({
  subdomain: process.env.REACT_APP_PUBLIC_BACKEND_ENDPOINT,
  region: "eu-central-1"
});

export { nhost };
